import React from "react";
import FiltreLocalisationDto from "../../../models/interfaces/dtos/filtre-localisation-dto";

export interface LocationContextProps {
    isLoading: boolean;
    error: unknown;
    data: FiltreLocalisationDto[] | undefined;
    
    selectedLocations: number[];
    setSelectedLocations: (locations: number[]) => void;
    
    filterDataLocations: (number | null)[],
    setFilterDataLocations: (locations: (number | null)[]) => void;
}

export const LocationContext = React.createContext<LocationContextProps | undefined>(undefined);